module.exports = __webpack_public_path__ + "img/evaluateImg04.12d84252.png";